module.exports = __webpack_public_path__ + "static/media/share.82e20832.svg";